/**
 * Environment for Amplitude's shared `environment` property and for selecting
 * the Amplitude write key.
 *
 * Production is the exact tenants.entrata.com host. Dev/staging uses the
 * Entrata dev domain; other hosts are blocked by the host gate.
 */

export const ENVIRONMENTS = {
  PRODUCTION: 'production',
  STAGING: 'staging',
}

const PRODUCTION_HOST_RE = /^tenants\.entrata\.com$/i

// Amplitude is enabled on the Entrata dev/staging domain.
const DEV_HOST_RE = /\.entratadev\.com$/i

const getWindowHostname = () =>
  typeof window !== 'undefined' && window.location
    ? window.location.hostname
    : ''

/**
 * @returns {'production'|'staging'} based on the current host.
 */
export const getEnvironment = ({ hostname } = {}) =>
  PRODUCTION_HOST_RE.test(hostname ?? getWindowHostname())
    ? ENVIRONMENTS.PRODUCTION
    : ENVIRONMENTS.STAGING

/**
 * Whether Amplitude should run on tenants.entrata.com or *.entratadev.com.
 * @param {Object} [options]
 * @param {string} [options.hostname] - override for tests.
 * @returns {boolean}
 */
export const isAnalyticsEnabledHost = ({ hostname } = {}) => {
  const host = hostname ?? getWindowHostname()
  return PRODUCTION_HOST_RE.test(host) || DEV_HOST_RE.test(host)
}

/**
 * Boolean convenience wrapper for production environment detection.
 * @returns {boolean}
 */
export const isProduction = options =>
  getEnvironment(options) === ENVIRONMENTS.PRODUCTION

export default getEnvironment
